"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyExportInterfaces = exports.createExportInterfaces = void 0;
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var getConfigData_1 = require("../autoModule/getConfigData");
var createExportInterfaces = function (exports, model) {
    return new MyExportInterfaces(exports, model);
};
exports.createExportInterfaces = createExportInterfaces;
var MyExportInterfaces = /** @class */ (function () {
    function MyExportInterfaces(exports, model) {
        var _this = this;
        this.getConfig = function () {
            if (!_this.config) {
                _this.config = (0, getConfigData_1.getConfigData)(_this.model);
            }
            return _this.config;
        };
        this.getComponents = function () {
            if (!_this.components) {
                _this.components = _this.createComponentList();
            }
            return _this.components;
        };
        this.createProcessedExports = function () {
            var _a, _b;
            var exportPayload = _this.exports;
            var config = _this.getConfig();
            if (config.exports) {
                (_b = (0, Arrays_1.getKeys)((_a = config.exports) !== null && _a !== void 0 ? _a : {})) === null || _b === void 0 ? void 0 : _b.forEach(function (key) {
                    var _a;
                    var _b, _c, _d, _e;
                    var exp = (_b = config.exports) === null || _b === void 0 ? void 0 : _b[key];
                    exportPayload = __assign(__assign({}, exportPayload), (_a = {}, _a[key] = __assign(__assign({}, (_c = config.exports) === null || _c === void 0 ? void 0 : _c[key]), { interfaces: [], name: (_d = _this.model.getDerivedFunction("exportName", key)) !== null && _d !== void 0 ? _d : (_e = exportPayload[key]) === null || _e === void 0 ? void 0 : _e.name }), _a));
                    exp === null || exp === void 0 ? void 0 : exp.interfaces.forEach(function (int) {
                        var _a, _b, _c, _d;
                        var processedInterface = _this.getInterface(key, int.interfaceId);
                        if (processedInterface) {
                            exportPayload[key].interfaces.push(__assign(__assign({}, processedInterface), { payload: (_b = (_a = _this.model) === null || _a === void 0 ? void 0 : _a.getDerivedFunction(int.interfaceId.name + "_payload")) !== null && _b !== void 0 ? _b : {}, payloads: (_d = (_c = _this.model) === null || _c === void 0 ? void 0 : _c.getDerivedFunction(int.interfaceId.name + "_payloads")) !== null && _d !== void 0 ? _d : {} }));
                        }
                    });
                });
            }
            return exportPayload;
        };
        this.getInterfaceArgs = function (interfaceKey, interfaceId) {
            var _a;
            return (_a = _this.getInterface(interfaceKey, interfaceId)) === null || _a === void 0 ? void 0 : _a.args;
        };
        this.getInterfaceResults = function (interfaceKey, interfaceId) {
            var _a;
            return (_a = _this.getInterface(interfaceKey, interfaceId)) === null || _a === void 0 ? void 0 : _a.results;
        };
        this.createComponentList = function () {
            var _a, _b;
            var componentList = [];
            var exports = (_a = _this.getConfig().exports) !== null && _a !== void 0 ? _a : {};
            (_b = (0, Arrays_1.getKeys)(exports)) === null || _b === void 0 ? void 0 : _b.forEach(function (key) {
                var exp = exports[key];
                exp.interfaces.forEach(function (int) {
                    if (int.components) {
                        componentList.push.apply(componentList, int.components);
                    }
                });
            });
            return componentList;
        };
        this.isControlledByInterface = function (componentName) {
            return _this.getComponents().indexOf(componentName) != -1;
        };
        this.getProcessedArgValue = function (componentName) {
            var _a, _b;
            var processedArgValue;
            var interfaceData = _this.getInterfaceData();
            if (_this.model &&
                _this.model.getDerivedFunctions().getProcessedArgValue &&
                interfaceData != undefined) {
                processedArgValue = (_b = (_a = _this.model
                    .getDerivedFunctions()) === null || _a === void 0 ? void 0 : _a.getProcessedArgValue) === null || _b === void 0 ? void 0 : _b.call(_a, componentName, interfaceData);
            }
            return processedArgValue;
        };
        this.getInterfaceData = function () {
            var _a, _b;
            var argValues;
            var exports = (_a = _this.getConfig().exports) !== null && _a !== void 0 ? _a : {};
            (_b = (0, Arrays_1.getKeys)(exports)) === null || _b === void 0 ? void 0 : _b.forEach(function (key) {
                var exp = exports[key];
                exp.interfaces.forEach(function (int) {
                    var _a;
                    var args = _this.getInterfaceArgs(key, int.interfaceId);
                    if (args) {
                        (_a = (0, Arrays_1.getKeys)(args)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                            var _a;
                            (_a = (0, Arrays_1.getKeys)(args[key])) === null || _a === void 0 ? void 0 : _a.forEach(function (arg) {
                                if (!argValues)
                                    argValues = [];
                                argValues.push({
                                    interface: int.interfaceId.name,
                                    name: arg,
                                    value: args[key][arg],
                                    module: key,
                                });
                            });
                        });
                    }
                });
            });
            return argValues;
        };
        this.exports = exports;
        this.model = model;
    }
    MyExportInterfaces.prototype.getInterface = function (interfaceKey, interfaceId) {
        var _a;
        if (!this.exports[interfaceKey])
            return undefined;
        return (0, Arrays_1.find)((_a = this.exports[interfaceKey].interfaces) !== null && _a !== void 0 ? _a : [], function (i) { return JSON.stringify(i.interfaceId) === JSON.stringify(interfaceId); });
    };
    return MyExportInterfaces;
}());
exports.MyExportInterfaces = MyExportInterfaces;
//# sourceMappingURL=exports.js.map